package com.trevorwiebe.timesheet.admin.organization.presentation

import kotlinx.datetime.LocalDate

sealed class OrganizationEvent {
    data class OnNameChanged(val name: String) : OrganizationEvent()
    data class OnGoLiveDateChanged(val date: LocalDate) : OrganizationEvent()
    data class OnBillingAddressChanged(val text: String) : OrganizationEvent()
    data class OnBillingPhoneChanged(val text: String) : OrganizationEvent()
    data class OnBillingEmailChanged(val text: String) : OrganizationEvent()
    data class OnRemitToChanged(val text: String) : OrganizationEvent()
    data object OnSave : OrganizationEvent()
    data object OnErrorShown : OrganizationEvent()
    data object OnSavedHandled : OrganizationEvent()
}
